module.exports = "pegasus/assets/email1-column-2.png";